import { 
    AlertDialog, 
    AlertDialogOverlay, 
    AlertDialogContent, 
    AlertDialogHeader, 
    AlertDialogBody, 
    AlertDialogFooter, 
    Button 
} from '@chakra-ui/react';
import React from 'react';

export function StatusToggleModal({
    disclosure,
    rcValue,
    onConfirm,
}: {
    disclosure: any;
    rcValue: any;
    onConfirm: () => void;
}) {
    const cancelRef = React.useRef<HTMLButtonElement>(null);

    return (
        <AlertDialog
            isOpen={disclosure.isOpen}
            leastDestructiveRef={cancelRef}
            onClose={disclosure.onClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Confirm Status Change
                    </AlertDialogHeader>
                    <AlertDialogBody>
                        Are you sure you want to {rcValue.isActive ? 'deactivate' : 'activate'} this Remote Config value?
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={disclosure.onClose}>
                            Cancel
                        </Button>
                        <Button colorScheme="blue" onClick={onConfirm} ml={3}>
                            Yes, Confirm
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}
